export const EDIT_MODE_GUTTER = 56
export const APP_BAR_WIDTH = 60
